import React from 'react';
import { MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
import { business } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  const sectionLinks = [{
    href: '#nosotros',
    label: t.nav.about
  }, {
    href: '#servicios',
    label: t.nav.services
  }, {
    href: '#barberos',
    label: t.nav.barbers
  }, {
    href: '#galeria',
    label: t.nav.gallery
  }, {
    href: '#agendar',
    label: t.nav.book
  }, {
    href: '#ubicacion',
    label: t.nav.location
  }];
  return <footer className="w-full bg-ink py-14" data-id="element-128" data-mp="36mrsgl2ksqw">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-129" data-mp="3lf56wppurnlv">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-130" data-mp="3lgonkhff80o6">
          <div className="sm:col-span-2 lg:col-span-1" data-id="element-131" data-mp="3qbvojhhb2r9e">
            <img src={business.logo} alt={`Logo ${business.name}`} className="h-20 w-20 rounded-full object-cover ring-1 ring-gold/40" data-id="element-132" data-mp="29yno3sf6hjhp" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-cream/60" data-id="element-133" data-mp="3l9acngdir03d">{t.footer.about}</p>
          </div>

          <div data-id="element-134" data-mp="3gb8v4zvqr8u0">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-135" data-mp="3gbikcl8ypbyn">
              {t.footer.contactTitle}
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-cream/70" data-id="element-136" data-mp="3q8n0a3c7sb70">
              <li className="flex items-start gap-2" data-id="element-137" data-mp="3q7bxo6ui99hh">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-138" data-mp="828n46lrs59o" />
                <a href={business.phoneHref} className="hover:text-gold-light" data-id="element-139" data-mp="34gyblgf8z9p">
                  {business.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-140" data-mp="huwgerdjjr3n">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-141" data-mp="curzj08q0ucw" />
                <span data-id="element-142" data-mp="qsq9zujx86n4">{business.address}</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-143" data-mp="mrwqrehfbg0k">
                <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-144" data-mp="mthk50s04swu" />
                <span data-id="element-145" data-mp="twfnbqzkfrqu">{t.footer.hoursShort}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-146" data-mp="yuzdk3l6zpp0">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-147" data-mp="yuh60at2xp1s">
              {t.footer.sectionsTitle}
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-cream/70" data-id="element-148" data-mp="18k943f0e10b0">
              {sectionLinks.map(link => <li key={link.href} data-id="element-149" data-mp="1ckkqoxcb9ap4">
                  <a href={link.href} className="hover:text-gold-light" data-id="element-150" data-mp="1cnoz66wt6sll">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-151" data-mp="1mhpawrmliw3a">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-152" data-mp="1riv5yw3qavfz">
              {t.footer.areaTitle}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-cream/70" data-id="element-153" data-mp="3ocgh0llhr757">{t.footer.areaText}</p>
          </div>
        </div>

        <div className="hairline my-10" data-id="element-154" data-mp="3tahyx376l0f3" />

        <div className="flex flex-col gap-2 text-xs text-cream/45 sm:flex-row sm:items-center sm:justify-between" data-id="element-155" data-mp="2afnb380l5ty6">
          <p data-id="element-156" data-mp="25ncb655ui85m">
            © {new Date().getFullYear()} {t.footer.rights}
          </p>
          <p data-id="element-157" data-mp="21ma6h8t5t3w9">{t.footer.languages}</p>
        </div>
      </div>
    </footer>;
}